function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Da Guo");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u0421\\u043B\\u043E\\u0439_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  className: "cls-1",
  width: 44.84,
  height: 5.5
}), React.createElement("rect", {
  className: "cls-1",
  y: 62.73,
  width: 44.84,
  height: 5.5
}), React.createElement("rect", {
  className: "cls-1",
  x: 58.88,
  y: 62.73,
  width: 28.88,
  height: 5.5
}), React.createElement("rect", {
  className: "cls-1",
  x: 58.88,
  y: 27.93,
  width: 28.88,
  height: 5.5
}), React.createElement("rect", {
  className: "cls-1",
  x: 39.34,
  y: 5.5,
  width: 5.5,
  height: 57.23
}), React.createElement("rect", {
  className: "cls-1",
  x: 58.88,
  y: 33.43,
  width: 5.5,
  height: 29.3
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 87.76 68.23",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.77dc8d04.svg";
export { ForwardRef as ReactComponent };